export class NumberUtils {
  static formatNumber(value: number) {
    if (value === null || value === undefined) {
      return '-'
    }
    return value.toLocaleString('pt-BR')
  }
}
